<script lang="ts">
  import { DrawerDescription, DrawerHeader, DrawerTitle } from "$lib/ui/drawer";

  interface Props {
    connectionId: string;
    emailsLength: number;
  }

  let { connectionId, emailsLength }: Props = $props();
</script>

<!-- <DrawerContent> -->
<DrawerHeader class="pt-8 px-6 pb-4 relative">
  <DrawerTitle class="text-3xl text-left">Invite sent successfully</DrawerTitle>
  <DrawerDescription>
    An email has been sent to <span class="font-semibold">{emailsLength} {emailsLength > 1 ? "admins" : "admin"}</span>
    requesting {connectionId}
    access.
  </DrawerDescription>
</DrawerHeader>
<div class="flex flex-col px-6 mt-5"></div>
<!-- </DrawerContent> -->
